import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FollowersCount = _resolveComponent("FollowersCount")!

  return (_openBlock(), _createBlock(_component_FollowersCount, {
    modelValue: _ctx.selectedOptions,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedOptions) = $event)),
    items: _ctx.followersCount,
    classes: "large-text"
  }, null, 8, ["modelValue", "items"]))
}